import { State } from 'business/models/Models';
import RMCustomButton, {
  RMCustomButtonProps,
} from 'components/customComponents/CommonComponents/RMCustomButton/RMCustomButton';
import RMSvgIcon from 'components/customComponents/CommonComponents/RMSvgIcon';
import RMTable from 'components/customComponents/Controls/RMTable';
import React, { useMemo, useState } from 'react';
import { useRMDispatch } from 'redux/hooks';
import { useAliasErrors, useIngredientAliases } from 'redux/hooks/IngredientDetail';
import {
  addAlias,
  removeAliases,
  updateAliasById,
} from 'redux/reducers/ingredientDetailReducer';
import { IStyle } from 'Styles';
import { getNewId } from 'utils/Global';

const ALIAS_COLUMNS = [{ accessor: 'name', Header: 'Aliases' }];

const Aliases = () => {
  const [selectedRows, setSelectedRows] = useState([]);
  const aliases = useIngredientAliases();
  const aliasErrors = useAliasErrors();
  const dispatch = useRMDispatch();

  const onCellChanged = (e, aliasId) => {
    dispatch(
      updateAliasById({
        id: aliasId,
        name: e.target.value,
        state: aliasId > 0 ? State.Updated : State.New,
      }),
    );
  };

  const handleAddAlias = () => {
    dispatch(addAlias({ id: getNewId(), name: '', state: State.New }));
  };

  const handleDeleteAliases = () => {
    if (selectedRows?.length) {
      dispatch(
        removeAliases(
          selectedRows.map((i) => {
            return aliases[i];
          }),
        ),
      );
      setSelectedRows([]);
    }
  };

  const addAliasIcon: RMCustomButtonProps = {
    Icon: <RMSvgIcon id='aliases-svg-add-icon' name="New" className="w-8 h-8 cursor-pointer" />,
    titleTip: 'Add Aliases',
    onClick: handleAddAlias,
  };

  const deleteAliasIcon: RMCustomButtonProps = {
    Icon: (
      <RMSvgIcon id='aliases-svg-del-icon' subfolder="Setup" name="Remove" className="w-8 h-8 cursor-pointer" />
    ),
    titleTip: 'Delete Aliases',
    onClick: handleDeleteAliases,
  };

  const aliasesRows = useMemo(
    () =>
      aliases.map((a) => {
        return {
          name: (
            <input
              id="aliases-aliasesrows-input-name"
              autoFocus
              type="text"
              className="w-full border-none bg-transparent text-left h-8"
              onChange={(e) => onCellChanged(e, a.id)}
              value={a.name}
            />
          ),
        };
      }),
    [aliases, onCellChanged],
  );

  const handleSelectionChange = (rowIndices) => {
    setSelectedRows([...rowIndices]);
  };

  return (
    <div
      id="aliases-main-container"
      className="flex basis-full flex-col max-h-full dashed-border"
    >
      <div id="aliases-title" className="basis-1/12 p-2 font-bold">
        Aliases
      </div>
      <div id="aliases-table" className="basis-8/12 flex max-h-[12vh]">
        <RMTable
          data={aliasesRows}
          columns={ALIAS_COLUMNS}
          selectedIds={selectedRows}
          rowExtraInfo={aliasErrors}
          onCheckboxSelectionChange={handleSelectionChange}
          mainContainerStyle={styles.tableStyle}
          cellClassName="justify-start"
        />
      </div>
      <div id="aliases-buttons" className="basis-3/12 flex gap-2 px-2 pb-1 items-end">
        <RMCustomButton {...addAliasIcon} />
        <RMCustomButton {...deleteAliasIcon} />
      </div>
    </div>
  );
};

const styles: IStyle = {
  tableStyle: {
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
  },
};

export default Aliases;
